function AgeValidator() {

    return {
        restrict: 'A',
        require: 'ngModel',
        link: (scope, element, attrs, ctrl) => {

            let minimumAge = 18;

            attrs.$observe('minimumAge', (ageCheck) => {
                 if (ageCheck) {
                     minimumAge = parseInt(ageCheck, 10);
                 }
            });

            ctrl.$parsers.unshift((value) => {

                let isAgeValid = false;

                if (value) {
                    // test and set the validity after each change.
                    const age = parseInt(value, 10);
                    isAgeValid = (age >= minimumAge);
                    ctrl.$setValidity('minimumAge', isAgeValid);
                }

                // if it's valid, return the value to the model,
                return isAgeValid ? value : null;
            });
        }
    };
}

module.exports = AgeValidator;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/age-validator.js
 **/